import React, { useState } from 'react';
import PropTypes from 'prop-types';

import StripeChargeModalPaymentSummaryLineItemV2 from './StripeChargeModalPaymentSummaryLineItemV2';

function TaxTooltip({ taxBreakdown }) {
  return (
    <div>
      {taxBreakdown?.map(item => (
        <div className="pt3" key={item.heading}>
          <p className="font-16 fw-medium">{item.heading}</p>
          <p className="font-14">{item.description}</p>
        </div>
      ))}
    </div>
  );
}

TaxTooltip.propTypes = {
  taxBreakdown: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      description: PropTypes.string
    })
  )
};

function MobileTooltipDisplay({ taxBreakdown }) {
  return (
    <div className="MobileTooltipDisplay">
      <div className="mb6 bb b--lightest-gray">
        <h5 className="font-20 pb3 pt1 tc">Taxes</h5>
      </div>
      <div className="ph4">
        <p className="font-14">
          Required state and local taxes are determined by pickup location.
        </p>
        <TaxTooltip taxBreakdown={taxBreakdown} />
      </div>
    </div>
  );
}

MobileTooltipDisplay.propTypes = {
  taxBreakdown: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      description: PropTypes.string
    })
  )
};

function DesktopModalDisplay({ taxBreakdown }) {
  return (
    <div className="DesktopModalDisplay pv5">
      <div className="container">
        <div className="row pb3 mb6 bb b--lightest-gray">
          <h5 className="font-20 col tc">Taxes</h5>
        </div>
        <div className="row pb6 ph8">
          <p className="font-14">
            Required state and local taxes are determined by pickup location.
          </p>
          <TaxTooltip taxBreakdown={taxBreakdown} />
        </div>
      </div>
    </div>
  );
}

DesktopModalDisplay.propTypes = {
  taxBreakdown: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      description: PropTypes.string
    })
  )
};

/** @param {any} props */
export default function StripeChargeModalTaxLineItem({
  amountInDollars,
  taxBreakdown,
  longDescription = null,
  ...restProps
}) {
  const rest = { longDescription, ...restProps };

  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  return (
    <StripeChargeModalPaymentSummaryLineItemV2
      iconProps={{ name: 'fetch-info' }}
      amountInDollars={amountInDollars}
      {...rest}
      tooltipProps={{
        minWidth: '250px',
        title: <MobileTooltipDisplay taxBreakdown={taxBreakdown} />,
        isVisible: isTooltipOpen,
        onClick: () => setIsTooltipOpen(true),
        onCloseTooltipClick: () => setIsTooltipOpen(false)
      }}
      modalProps={{
        content: <DesktopModalDisplay taxBreakdown={taxBreakdown} />
      }}
    />
  );
}

StripeChargeModalTaxLineItem.propTypes = {
  amountInDollars: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  longDescription: PropTypes.string,
  taxBreakdown: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      description: PropTypes.string
    })
  )
};
